import * as types from '../types';
import { IAuthApi } from '../contracts';
import { HttpApi } from './HttpApi';

export class AuthHttpApi extends HttpApi implements IAuthApi {
  async login(tenantSlug: string, email: string, password: string): Promise<types.LoginResponse> {
    const response = await this.http.post<types.APIResponse<types.LoginResponse | types.MfaLoginChallenge>>('/auth/login', {
      tenantSlug,
      email,
      password,
    });
    const data = response.data.data;
    // MFA on (tracker item 63): the password was right but there is no session yet
    if ('mfaRequired' in data && data.mfaRequired) {
      throw new types.MfaChallengeRequiredError(data.challengeToken, data.expiresAt);
    }
    return data as types.LoginResponse;
  }

  async verifyMfaLogin(challengeToken: string, factor: types.MfaFactor): Promise<types.LoginResponse> {
    const response = await this.http.post<types.APIResponse<types.LoginResponse>>('/auth/mfa/verify', {
      challengeToken,
      ...factor,
    });
    return response.data.data;
  }

  async logout(): Promise<void> {
    await this.http.post('/auth/logout');
    this.core.clearAuthToken();
  }

  async verifyToken(token: string): Promise<types.VerifyResponse> {
    const response = await this.http.post<types.APIResponse<types.VerifyResponse>>('/auth/verify', {
      token,
    });
    return response.data.data;
  }
}
